import mime from 'mime-types'
import CanvasToTiff from 'services/CanvasToTiff'

const MAX_FILE_SIZE_MB = 5
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024

export async function getResizedImage(file: File, url: string, maxSize: number) {
  const parts = file.name.split('.')
  const filenamePrefix = (parts.length > 1 ? parts.slice(0, -1) : parts).join('.')
  const filename = [filenamePrefix, mime.extension(file.type)].join('.')
  const quality = file.type.includes('jpeg') ? 0.75 : undefined

  return new Promise<File | null>((resolve) => {
    const img = document.createElement('img')
    img.onload = (evt: any) => {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')!
      const { width, height } = getShrinkDimensions(evt.target.height, evt.target.width, maxSize)
      canvas.width = width
      canvas.height = height
      ctx.drawImage(img, 0, 0, width, height)

      const handleBlob = (blob: Blob | null) => {
        if (!blob) {
          resolve(null)
          return
        }

        if (blob.size <= MAX_FILE_SIZE_BYTES) {
          resolve(
            new File([blob], filename, {
              type: file.type,
            })
          )
          return
        }

        const width = canvas.width * 0.9
        const height = canvas.height * 0.9
        canvas.width = width
        canvas.height = height
        ctx.drawImage(img, 0, 0, width, height)
        canvas.toBlob(handleBlob, file.type, quality)
      }

      canvas.toBlob(handleBlob, file.type, quality)
    }
    img.src = url
  })
}

function getShrinkDimensions(naturalHeight: number, naturalWidth: number, maxDimensionSize: number) {
  let height = 0
  let width = 0
  let ratio = 1

  if (naturalHeight <= maxDimensionSize && naturalWidth <= maxDimensionSize) {
    height = naturalHeight
    width = naturalWidth
  } else if (naturalHeight > naturalWidth) {
    height = maxDimensionSize
    ratio = maxDimensionSize / naturalHeight
    width = naturalWidth * ratio
  } else {
    width = maxDimensionSize
    ratio = maxDimensionSize / naturalWidth
    height = naturalHeight * ratio
  }

  return { height, width }
}

export async function getImageOnCanvas(image: string | Blob | File): Promise<HTMLCanvasElement> {
  return new Promise((resolve) => {
    const img = document.createElement('img')
    img.crossOrigin = 'anonymous'
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = img.naturalWidth
      canvas.height = img.naturalHeight
      const ctx = canvas.getContext('2d')!
      ctx.drawImage(img, 0, 0)
      resolve(canvas)
      if (typeof image !== 'string') {
        URL.revokeObjectURL(img.src)
      }
    }
    img.src = typeof image === 'string' ? image : URL.createObjectURL(image)
  })
}

export async function convertImageToTiff(image: string | Blob | File): Promise<Blob> {
  const canvas = await getImageOnCanvas(image)
  return new Promise((resolve) => {
    CanvasToTiff.toBlob(canvas, resolve)
  })
}
